import React, { useState } from 'react';
import './RoutesDeliveries.css';
import { RouteDialog } from "../RouteDialog";
import { Subject } from "rxjs";
import { FormPane } from "../../../components/FormZero/PageComponents/FormPane/FormPane";
import { DebugView } from "../../../components/FormZero/DebugView/DebugView";
import axios from "axios";
import Button from '@mui/material/Button';
import { useNavigate } from "react-router-dom";
import { get_number_of_trays_per_cart, isFlaggedNumberOfCarts } from "../../CommonInfo";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { setPageTitle } from "../../../slices/applicationSlice";
import { IApplication } from "../../../interfaces/IApplication";
import { useAppDispatch } from "../../../hooks";
import { useEffect } from "react";
import { Unstable_Grid2 as Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import EmailIcon from '@mui/icons-material/Email';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import Link from '@mui/material/Link';
import ActionButton from '../../../components/ActionButton';
import ActionMenu from '../../../components/ActionMenu';
import { CustomDataGrid } from '../../../components/StripedDataGrid';
import SearchChips from '../../../components/SearchChips';
import { ISearchChips } from '../../../interfaces/Core/ISearchChips';



/* function PanelView() {
    let history = useNavigate();
    

    return (
        <>
            <div className="SprayRecordsGrid_PanelView">
                <div className="row">
                    <div className="col-6">
                        <Button
                            // disabled={true}
                            fullWidth={true}
                            className="button-square"
                            clickHandler={() => openRouteManager()}
                            // color={"secondary"}
                            text={"Route Manager"}
                        />
                    </div>
                    <div className="col-6">

                    </div>
                </div>

            </div>
        </>
    )
} */

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

type Anchor = 'top' | 'left' | 'bottom' | 'right';

export function RoutesDeliveries() {

    function RouteClicked(_event: React.MouseEvent<HTMLElement>): void {

        openRouteManager();
    }

    const navigate = useNavigate();

    const openRouteManager = () => {
        navigate("/logistics/routemanager");
    };

    const [open, setOpen] = useState(false);

    function handleClose() {
        setOpen(!open);
    }

    const buttons = [
        <ActionButton action={RouteClicked} buttonLabel="ROUTE MANAGER" />,
    ];



    const dispatch = useAppDispatch();

    useEffect(() => {
        let appState: IApplication = {
            pageTitle: "Routes Deliveries",
            backgroundPath: "/assets/images/patchingbg.jpg"
        }
        dispatch(setPageTitle(appState));
    }, []);





    const [helpOpen, setHelpOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClickHelpOpen = () => {
        setHelpOpen(true);
    };

    const handleHelpClose = () => {
        setHelpOpen(false);
    };

    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });


    const filterFormSubject = new Subject();
    const [formFilter, setFormFilter] = React.useState<any>({});
    filterFormSubject.subscribe((n) => setFormFilter(n));

    const [routes, setRoutes] = React.useState([]);
    const [loads, setLoads] = React.useState<any>([]);
    const loadRoutes = async function () {
        try {
            // const result 
            const response = await axios.get(`${process.env.REACT_APP_ENDPOINT}/api/Routes`);
            setRoutes(response.data);
            // setExpanded(expanded);
        }
        catch (e) {
            console.log(e);
            // setResult(e);
        }
    };
    const loadLoads = async function () {
        let outputRows: any[] = [];
        const response = await axios.get(`${process.env.REACT_APP_ENDPOINT}/api/DeliveryHeaders/`); //${weekObj.week}/${weekObj.year}
        if (response.status === 200) {
            // TODO: refresh the table on the main page? or location.reload
            console.log(response);
            outputRows = [...outputRows, ...response.data]
            
        }
        console.log("OUTPUT ROWS", outputRows);
        setLoads(response.data);
        
        // if (formFilter === undefined || formFilter === null || formFilter['week_year'] === undefined || formFilter['week_year'] === null || formFilter['week_year'] === "") {
        //     setLoads([]);
        //     return;
        // }
        // try {

        //     let outputRows: any[] = [];
        //     await formFilter['week_year'].forEachAsync(async (weekObj: { week: any; year: any; }) => {
        //         console.log("WEEK OBJ", weekObj);
        //         const response = await axios.get(`${process.env.REACT_APP_ENDPOINT}/api/DeliveryHeaders/`); //${weekObj.week}/${weekObj.year}
        //         if (response.status === 200) {
        //             // TODO: refresh the table on the main page? or location.reload
        //             console.log(response);
        //             outputRows = [...outputRows, ...response.data]
        //         }
        //     });
        //     // setLoads(outputRows);
        //     // setLoads(outputRows.filter((x) => {
        //     //     return x.current_load === null || !x.current_load.Shipped
        //     // }));
        // } catch (err) {
        //     console.log(err);
        // }
    };
    React.useEffect(() => {
        loadRoutes().then();
        loadLoads().then();
    }, []);

    React.useEffect(() => {
        loadLoads().then();
    }, [formFilter['week_year']]);

    const updateView = () => {
        loadRoutes().then();
        loadLoads().then();
    }

    const [selectionModel, setSelectionModel] = useState([]);



    const columns: GridColDef[] = [
        { field: 'id', headerName: 'Delivery #', width: 200 },
        { field: 'brokerDeliveryID', headerName: 'Delivery #', width: 200 },
        // // TODO: make button here and then make a dialog with a select box in it.
        // {
        //     field: "change_route_button_dialog",
        //     headerName: ' ',
        //     width: 150,
        //     renderCell: (cellValues: { row: { current_load: { id: any; logistics_route_id: any; } | null; }; }) => {
        //         return (
        //             <>
        //                 {/*<RouteDialog cellValues={cellValues} />*/}
        //                 <RouteDialog
        //                     // currentDeliveryNumber={cellValues.row['BrokerDeliveryID']}
        //                     // delivery={cellValues.row}
        //                     cellValues={cellValues}
        //                     // currentLoad={cellValues.row.current_load}
        //                     currentLoad={(cellValues.row.current_load !== null) ? cellValues.row.current_load.id : ""}
        //                     currentRoute={(cellValues.row.current_load !== null) ? cellValues.row.current_load.logistics_route_id : ""}
        //                     //dataSource={sampleData}
        //                     routes={routes}
        //                     updateView={updateView}
        //                     routeOnly={true}
        //                 />
        //             </>
        //         );
        //     }
        // },
        // {
        //     field: 'Route', headerName: 'Route', width: 200,
        //     valueGetter: (cellParams: { row: { current_load: { route: { RouteName: any; }; } | null; }; }) => (cellParams.row.current_load !== null) ? cellParams.row.current_load.route.RouteName : ""
        // },
        // {
        //     field: "logistics_loads_id", headerName: "Load", width: 130,
        //     valueGetter: (cellParams: { row: { current_load: { LoadNumber: any; } | null; }; }) => (cellParams.row.current_load !== null) ? cellParams.row.current_load.LoadNumber : ""
        // },
        { field: 'shipToName', headerName: 'Customer Name', width: 200 },
        { field: 'shipToCity', headerName: 'City', width: 200 },
        { field: 'shipToState', headerName: 'State', width: 200 },
        // // { field: 'number_of_items', headerName: '# of Items', width: 200 },
        // {
        //     field: "number_of_items", headerName: "# of Items", width: 150,
        //     valueGetter: (cellParams: { row: { items: string | any[] | null; }; }) => (cellParams.row.items !== null) ? cellParams.row.items.length : 0
        // },
        // {
        //     field: 'number_of_trays', headerName: '# of Trays', width: 200,
        //     valueGetter: (cellParams: { row: { items: any[] | undefined; }; }) => {
        //         if (cellParams.row.items === undefined) return 0;
        //         let list = cellParams.row.items.map((item: { OrderdQty: any; }) => item.OrderdQty);
        //         return list.reduce((t: string, s: string) => parseInt(t) + parseInt(s), 0);
        //     }
        // },
        // {
        //     field: 'number_of_carts', headerName: '# of Carts', width: 200,
        //     // valueGetter: (cellParams) => {
        //     //     if (cellParams.row.items === undefined) return 0;
        //     //     let totalFilled = 0;
        //     //             totalFilled += cellParams.row.items.reduce((t, item) => {
        //     //                 return t + get_number_of_trays_per_cart(item, item.OrderdQty);
        //     //             }, 0);
        //     //     return Math.ceil(totalFilled );
        //     // },
        //     renderCell: (cellValues: { row: { items: any[] | undefined; }; }) => {
        //         let totalFilled = 0;
        //         let isOneFlagged = false;
        //         if (cellValues.row.items !== undefined) {
        //             totalFilled += cellValues.row.items.reduce((t: number, item: { OrderdQty: any; }) => {
        //                 if (isFlaggedNumberOfCarts(item)) {
        //                     isOneFlagged = true;
        //                 }
        //                 return t + get_number_of_trays_per_cart(item, item.OrderdQty);
        //             }, 0);
        //         }
        //         let cartCount = Math.ceil(totalFilled);
        //         return (
        //             <>
        //                 <span style={{ color: isOneFlagged ? "#9C27B0" : "black" }}>{cartCount}</span>
        //             </>
        //         );
        //     }
        // },
    ];

    const formStructure = [

        { key: "week_year", type: "week-filter", size: { default: 4 }, label: "Patching Week", required: true },
        { key: "week_year_view", type: "header", size: { default: 4 }, valueKey: "week_year" },
    ];

    // const panel = (<PanelView />);

    const darkTheme = createTheme({
        palette: {
            mode: 'dark',
            primary: {
                main: '#89B219',
            },
        },
    });

    const [searchInformation, setSearchInformation] = React.useState<ISearchChips>();

    const handleSearchChips = (searchInformation: ISearchChips) => {
        setSearchInformation(searchInformation);
    }



    return (
        <>
            <div>
                <ActionMenu buttons={buttons} />
            </div>
            <Grid container spacing={0} bgcolor="#FFF" >
                <Grid xs={12}>
                    <ThemeProvider theme={darkTheme}>
                        <SearchChips handleSearch={handleSearchChips}></SearchChips>
                    </ThemeProvider>
                </Grid>
                <Grid xs={12}>
                    <div style={{ height: 'calc(100vh - 202px)', width: '100%' }}>
                        <CustomDataGrid
                            style={{ "width": "100%", 'maxWidth': '100%' }}
                            rows={loads}
                            columns={columns}
                            rowsPerPageOptions={[5, 10]}
                            checkboxSelection={true}
                            disableSelectionOnClick
                            selectionModel={selectionModel}
                        />
                    </div>
                </Grid>
                {/* <ActionPanel Body={panel}  /> */}

                <ThemeProvider theme={darkTheme}>
                    <div>
                        <BootstrapDialog
                            onClose={handleHelpClose}
                            aria-labelledby="customized-dialog-title"
                            open={helpOpen}
                        >
                            <BootstrapDialogTitle id="customized-dialog-title" onClose={handleHelpClose}>
                                Need Support?
                            </BootstrapDialogTitle>
                            <DialogContent dividers>
                                <Typography sx={{ mb: 3 }} variant="body2" gutterBottom>
                                    If you are having issues or have questions, please contact us below.
                                </Typography>
                                <Button size='large' fullWidth variant="contained" startIcon={<SmartphoneIcon />} sx={{ mb: 1, bgcolor: '#89B219' }}>
                                    <Link href="tel:8003141797" underline="none" color="#FFF"><Typography variant='h6' fontWeight={700}>800-314-1797</Typography></Link>
                                </Button>
                                <Button size='large' fullWidth variant="contained" startIcon={<EmailIcon />} sx={{ mb: 1, bgcolor: '#89B219' }}>
                                    <Link href="mailto:bobsmarket@idatp.com" underline="none">
                                        <Typography variant='h6' fontWeight={700} color="#FFF">support@idatp.com</Typography></Link>
                                </Button>
                            </DialogContent>
                        </BootstrapDialog>
                    </div>
                </ThemeProvider>
            </Grid>
        </>
    )
}
